import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import FinancialReports from './reports/FinancialReports';
import InvoiceManagement from './invoicing/InvoiceManagement';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <nav className="sidebar">
        <ul>
          <li>
            <Link to="/invoices">Invoicing</Link>
          </li>
          <li>
            <Link to="/reports">Financial Reports</Link>
          </li>
        </ul>
      </nav>
      
      <main className="content">
        <Routes>
          <Route path="/invoices/*" element={<InvoiceManagement />} />
          <Route path="/reports" element={<FinancialReports />} />
        </Routes>
      </main>
    </div>
  );
};

export default Home; 